import { render, staticRenderFns } from "./DogRegistrationIndividualRequestCard.vue?vue&type=template&id=84b581b2"
import script from "./DogRegistrationIndividualRequestCard.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports